import {useEffect} from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export default function detectOutsideClickHook(ref, callback=null) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if(callback && 'function'=== typeof callback){
          callback();
        }
      }
    }
    // Bind the event listener
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);
}
